import React from 'react';
import PropTypes from "prop-types";
import moment from "moment";

import Framework from "@beardeddevops/react.framework";
import {Parts} from "components";

class TransactionDetails extends React.Component {
	static propTypes = {
		object: PropTypes.object.isRequired,
		properties: PropTypes.object.isRequired,
		isDisposition: PropTypes.bool,
		locations: PropTypes.array.isRequired,
		onTextUpdate: PropTypes.func.isRequired,
		onSelectUpdate: PropTypes.func.isRequired,
		shouldLoad: PropTypes.bool.isRequired,
		afterEventSave: PropTypes.func.isRequired,
		history: PropTypes.object.isRequired,
		isNew: PropTypes.bool
	};

	static defaultProps = {
		isDisposition: false,
	}

	constructor(props, context) {
		super(props, context);
		this.state = {id: null};
	}

	render() {
		let {shouldLoad, onTextUpdate, onSelectUpdate, afterEventSave, isDisposition} = this.props;

		/** @type {Transactions_Collections_Properties} properties */
		let properties = this.props.properties

		/** @type {Transactions_Collections_Object} object */
		let object = this.props.object

		return (
			<div>
				<Parts.TransactionEvent
					shouldLoad={shouldLoad}
					locations={this.props.locations}
					states={this.props.states}
					object={object}
					properties={properties}
					history={this.props.history}
					onSelectUpdate={onSelectUpdate}
					afterEventSave={afterEventSave}
					isNew={this.props.isNew}
				/>

				<div className={'form-group'}>
					<div className="row">
						<div className="col-4">
							<span className="input-label">Date</span>
						</div>
						<div className={'col-8'}>
							{object.pkey ?
								<Framework.Elements.DateTime
									property={properties.date}
									value={object.date}
									update={onTextUpdate}
									error={object.date_error}
									defaultValue={moment().format('YYYY-MM-DD HH:mm:ss A')}
								/> :
								<Framework.Elements.Date
									property={properties.date}
									value={object.date}
									update={onTextUpdate}
									error={object.date_error}
									defaultValue={moment().format('YYYY-MM-DD')}
									appendTime={true}
								/>
							}
						</div>
					</div>
				</div>

				{isDisposition &&
				<div className="form-group">
					<div className={'row'}>
						<div className={'col-6'}>
							<span className="input-label">Pawn Redemption</span>
						</div>
						<div className={'col-6 text-right'}>
							<Framework.Elements.ButtonSwitch
								property={properties.pawn_redemption}
								value={object.pawn_redemption}
								error={object.pawn_redemption_error}
								update={onTextUpdate}
								{...(this.props.rootState.hasTwinCityPawnModule && { uncheck: true })}
								{...(this.props.rootState.hasTwinCityPawnModule && { nullable: true })}
								labelTrue={'Yes'}
								labelFalse={'No'}
							/>
						</div>
					</div>
				</div>}
				{isDisposition &&
				<div className="form-group">
					<div className={'row'}>
						<div className={'col-6'}>
							<span className="input-label">Private Party Transfer</span>
						</div>
						<div className={'col-6 text-right'}>
							<Framework.Elements.ButtonSwitch
								property={properties.private_party_transfer}
								value={object.private_party_transfer}
								error={object.private_party_transfer_error}
								update={onTextUpdate}
								labelTrue={'Yes'}
								labelFalse={'No'}
							/>
						</div>
					</div>
				</div>}
				<div className="form-group">
					<Framework.Elements.TextField
						property={properties.notes}
						value={object.notes}
						error={object.notes_error}
						update={onTextUpdate}
						multiline={4}
						label={isDisposition ? 'Notes for use by Licensee (field 32)' : 'Notes'}
					/>
				</div>

			</div>
		)
	}
}

export default Framework.Components.withRootState(TransactionDetails);